import RequiredFields from '@engine/features/virtual_terminal/vt_update_required_fields'; // LEGACY CODE
// TODO showOrHidePproAdditionalFields method needs rework.

function showOrHidePproAdditionalFields(selected) {
  var elements = {
    giropay: {
      makeFieldRequired: ['ppro_transaction_bic', 'ppro_transaction_iban'],
      makeFieldNotRequired: ['ppro_transaction_account_phone'],
      makeDivVisible: ['giropay_custom_attributes'],
      makeDivHidden: ['qiwi_custom_attributes']
    },
    qiwi: {
      makeFieldRequired: ['ppro_transaction_account_phone'],
      makeFieldNotRequired: ['ppro_transaction_bic', 'ppro_transaction_iban'],
      makeDivVisible: ['qiwi_custom_attributes'],
      makeDivHidden: ['giropay_custom_attributes']
    },
    hide_all: {
      makeFieldNotRequired: ['ppro_transaction_bic', 'ppro_transaction_iban', 'ppro_transaction_account_phone'],
      makeDivHidden: ['giropay_custom_attributes', 'qiwi_custom_attributes']
    }
  };

  if (elements[selected]) {
    $.each(elements[selected], function (method) {
      var methodAttributes = elements[selected][method];

      for (var attr = 0; attr < methodAttributes.length; attr += 1) {
        RequiredFields[method](elements[selected][method][attr]);
      }
    });
  }
}

function listenForPproPaymentMethodChange() {
  if ($('#virtual_terminal_ppro_payment_type').length) {
    var selected = $('#virtual_terminal_ppro_payment_type')[0].value;

    if (selected !== '') {
      showOrHidePproAdditionalFields(selected);
    }
  }

  $('#virtual_terminal_ppro_payment_type').on('change', function () {
    var value = $(this).val();

    if (['giropay', 'qiwi', 'hide_all'].indexOf(value) !== -1) {
      showOrHidePproAdditionalFields(value);
    } else {
      showOrHidePproAdditionalFields('hide_all');
    }
  });
}

var Ppro = {
  listenForPaymentMethodChange: listenForPproPaymentMethodChange
};
export default Ppro;